var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1434",
    "data-name": "Grupo 1434",
    transform: "translate(-1700 -13580)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_137",
    "data-name": "Elipse 137",
    cx: 35,
    cy: 35.5,
    rx: 35,
    ry: 35.5,
    transform: "translate(1705 13585)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_138",
    "data-name": "Elipse 138",
    transform: "translate(1700 13580)",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 40,
    ry: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 39.5,
    ry: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1588",
    "data-name": "Trazado 1588",
    d: "M90.872,32.081V17.466h4.99l.713-5.7h-5.7V8.2c0-1.6.535-2.852,2.852-2.852h3.03V.178C96.041.178,94.258,0,92.3,0,88.02,0,84.99,2.673,84.99,7.486v4.278H80v5.7h4.99V32.081Z",
    transform: "translate(1651.46 13606.188)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.75f4f2a4eb2a3afd06387b085d23cee9.svg";
export { ForwardRef as ReactComponent };